































import VueOptions from '@utils/VueOptions'

settings =
  name: 'SuperBar'

  vue:
    props: ['offer', 'actions']

    computed:
      canLock: ->
        !@offer.locked and @offer.accepted
      canUnlock: ->
        @offer.locked and !!(@$store.member.permissions || {}).accounting
      canVoid: ->
        (@offer.accepted || @offer.canceled) and !@offer.locked

      isProductSampling: ->
        @offer.activation_snapshot_space_names[0].startsWith 'product_sampling:'
      isOnsite: ->
        @offer.activation_snapshot_space_names[0].startsWith 'onsite_'

    methods:
      hiNavToPOEditPage: ->
        purchaseOrderId = @offer.purchase_order_id
        purchaseOrderItemId = @offer.purchase_order_line_items[0].id
        @$router.push({ name: 'PurchaseOrderLineItemEditPage', params: { purchaseOrderId, purchaseOrderItemId } })

export default VueOptions.vue settings
